// @flow
import auth from '../../../service/auth';
import fetchFromApiServer from '../../../service/index';

  export function getDetailOfSurvey(surveyUrl){
    var url = 'WMSDetail/GetSurveyDetail?surveyUrl=' + surveyUrl;
    
    return {
      type:'GET_SURVEY_DATA',
      payload:fetchFromApiServer("GET", url)
    }
  }
  export function selectSurveyOption(optionKey){
    return {
      type:'SELECT_SURVEY_OPTION',
      payload:optionKey
    }
  }
  export function selectLeadOption(data){
    return {
      type:'SELECT_LEAD_OPTION',
      payload:data
    }
  }
  export function submitSurvey(object){
    var url = 'WMSDetail/SubmitSurvey';
    return {
      type:'SUBMIT_SURVEY_OPTION',
      payload:fetchFromApiServer("POST", url, object)
    }
  }

  export function storeSurveyData(data){
    return {
      type:'STORE_SURVEY_DATA',
      payload:data
    }
  }
  
  export function handleChangeLeadQuestion(value,id){
    return {
      type:'EDITABLE_LEAD_QUESTION_OPTION',
      payload:{id,value}
    }
  }